export default __webpack_public_path__ + "static/hp-brand-deck-14-51158f8978dd62af71a586c1fb4b84fe.png";